import { IconProps } from "../../../types/style";

const BoxSearchIcon = (prop: IconProps) => {
  const { color = "#f5f5f5", size = 24 } = prop;
  return (
    <div style={{ height: size + "px" }}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.67017 7.44043L12.5002 12.5504L21.2701 7.4704"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.5002 21.61V12.54"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M22.1101 12.83V9.17C22.1101 7.79 21.1201 6.11002 19.9101 5.44002L14.5701 2.48C13.4301 1.84 11.5701 1.84 10.4301 2.48L5.09012 5.44002C3.88012 6.11002 2.89014 7.79 2.89014 9.17V14.83C2.89014 16.21 3.88012 17.89 5.09012 18.56L10.4301 21.52C11.0001 21.84 11.7501 22 12.5001 22C13.2501 22 14.0001 21.84 14.5701 21.52"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M19.7 21.4C21.4673 21.4 22.9 19.9673 22.9 18.2C22.9 16.4327 21.4673 15 19.7 15C17.9327 15 16.5 16.4327 16.5 18.2C16.5 19.9673 17.9327 21.4 19.7 21.4Z"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M23.5 22L22.5 21"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  );
};

export default BoxSearchIcon;
